<div class="modal-header">
  <h4 class="modal-title">Payment Details</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body pb-0" *ngIf="serverError">
  <p>Server error: {{ serverError }}</p>
</div>

<div class="modal-body pb-0" *ngIf="!serverError">

  <ng-container *ngIf="loadingPayment">
    <p>Loading...</p>
  </ng-container>

  <ng-container *ngIf="!loadingPayment && payment">

    <p>
      Payment ID: <b>{{ payment.id }}</b> <br>
      Invoice ID: <b>{{ payment.invoice_id }}</b> <br>
    </p>

    <p>
      Amount: <b>{{ orgConfig.formatCurrency(payment.amount) }}</b> <br>
      Status: <b>{{ getPaymentStatusDisplay(payment.status) }}</b> <br>
      <ng-container *ngIf="payment.failure_message">
        Failure Message: <b>{{ payment.failure_message }}</b> <br>
      </ng-container>
      <!--suppress TypeScriptValidateTypes -->
      <ng-container *ngIf="payment.amount_refunded > 0">
        Amount refunded: <b>{{ orgConfig.formatCurrency(payment.amount_refunded) }}</b> <br>
      </ng-container>
      Timestamp: <b>{{ dateStringFromISO8601(payment.created_at) }}, {{ timeStringFromISO8601(payment.created_at) }}</b> <br>
      Description: <b>{{ payment.invoice_description }}</b> <br>
      Customer:
      <b>
        <a *ngIf="payment.customer_id"
           target="_blank"
           routerLink="/customers/{{ payment.customer_id }}/payments">
          {{ payment.customer_first_name }} {{ payment.customer_last_name }}
        </a>
        <span *ngIf="!payment.customer_id" class="text-muted">
          Not linked
        </span>
      </b>
      <br>
      Location:
      <b>
        <ng-container *ngIf="payment.location_name">{{ payment.location_name }}</ng-container>
        <span class="text-muted" *ngIf="!payment.location_name">Unknown</span>
      </b>
      <br>
    </p>

    <p *ngIf="payment.discount_amount">
      Discount amount: <b>{{ orgConfig.formatCurrency(payment.discount_amount) }}</b> <br>
      Discount name(s): <b>{{ payment.discount_name }}</b> <br>
      Discount code(s): <b>{{ payment.discount_code }}</b> <br>
    </p>

    <p>
      Payment Method: <b>{{ getPaymentMethodTypeDisplay(payment.payment_type, payment.payment_method_type) }}</b> <br>
      <ng-container *ngIf="payment.payment_method_type === PaymentMethodType.card">
        Last 4 Digits:
        <b *ngIf="payment.credit_card_last4">{{ payment.credit_card_last4 }}</b>
        <span *ngIf="!payment.credit_card_last4" class="text-muted">Unknown</span>
        <br>
        Brand:
        <b *ngIf="payment.credit_card_brand">{{ capitalizeFirstLetter(payment.credit_card_brand) }}</b>
        <span *ngIf="!payment.credit_card_brand" class="text-muted">Unknown</span>
        <br>
      </ng-container>
      <ng-container *ngIf="payment.payment_method_type === PaymentMethodType.bankAccount">
        Last 4 Digits:
        <b *ngIf="payment.bank_account_last4">{{ payment.bank_account_last4 }}</b>
        <span *ngIf="!payment.bank_account_last4" class="text-muted">Unknown</span>
        <br>
        Bank:
        <b *ngIf="payment.bank_account_bank_name">{{ payment.bank_account_bank_name }}</b>
        <span *ngIf="!payment.bank_account_bank_name" class="text-muted">Unknown</span>
        <br>
      </ng-container>
      <ng-container *ngIf="payment.payment_type === PaymentType.posGiftCard">
        Gift Card Number:
        <b *ngIf="payment.gift_card_number">
          {{ payment.gift_card_number }}
        </b>
        <span *ngIf="!payment.gift_card_number" class="text-muted">
          Unknown
        </span>
        <br>
      </ng-container>
    </p>

    <p>
      Line Items <br>
      <ng-container *ngFor="let li of payment.line_items; let last = last;">
        <b *ngIf="getBookingId(li) === null">{{ li.description }}</b>
        <b *ngIf="getBookingId(li) !== null">
          <a [routerLink]="['/reporting/bookings']" [queryParams]="getBookingQueryParams(li)" target="_blank">{{ li.description }}</a>
        </b>
        {{ orgConfig.formatCurrency(li.amount) }}
        <br *ngIf="!last">
      </ng-container>
    </p>

    <p>
      Revenue Accounts <br>
      <ng-container *ngFor="let rawp of getRevenueAccountsWithPercentages(); let last = last;">
        <b>{{ rawp.revenueAccount }}</b> ({{ rawp.percentage }}%)
        <br *ngIf="!last">
      </ng-container>
    </p>

    <p *ngIf="payment.payment_type === PaymentType.stripe">
      Stripe Payment Intent ID:
      <b *ngIf="payment.stripe_payment_intent_id">
        {{ payment.stripe_payment_intent_id }}
      </b>
      <span *ngIf="!payment.stripe_payment_intent_id" class="text-muted">
        Unknown
      </span>
      <br>
    </p>
    <p *ngIf="payment.payment_type === PaymentType.gravity">
      Gravity External Transaction ID:
      <b *ngIf="payment.gravity_external_transaction_id">
        {{ payment.gravity_external_transaction_id }}
      </b>
      <span *ngIf="!payment.gravity_external_transaction_id" class="text-muted">
        Unknown
      </span>
      <br>
      Gravity Unique Transaction ID:
      <b *ngIf="payment.gravity_unique_transaction_id">
        {{ payment.gravity_unique_transaction_id }}
      </b>
      <span *ngIf="!payment.gravity_unique_transaction_id" class="text-muted">
        Unknown
      </span>
      <br>
    </p>
    <p *ngIf="payment.payment_type === PaymentType.mxMerchant">
      <ng-container *ngIf="payment.mx_merchant_payment_link_name">
        MX Merchant Payment Link Name: <b>{{ payment.mx_merchant_payment_link_name }}</b>
        <br>
      </ng-container>
      <ng-container *ngIf="payment.mx_merchant_payment_link_id">
        MX Merchant Payment Link ID: <b>{{ payment.mx_merchant_payment_link_id }}</b>
        <br>
      </ng-container>
      MX Merchant Payment ID:
      <b *ngIf="payment.mx_merchant_payment_id">
        {{ payment.mx_merchant_payment_id }}
      </b>
      <span *ngIf="!payment.mx_merchant_payment_id" class="text-muted">
        Unknown
      </span>
      <br>
    </p>

  </ng-container>

</div>

<div class="modal-footer justify-content-between" ngPreserveWhitespaces>
  <div>
    <button *ngIf="showDownloadReceipt()"
            type="button"
            class="btn btn-outline-primary"
            (click)="handleDownloadReceipt()">
      Download
      <span *ngIf="orgConfig.getOrganizationConfig().tax_display_format === TaxDisplayFormat.vat">VAT</span>
      <span *ngIf="orgConfig.getOrganizationConfig().tax_display_format === TaxDisplayFormat.gst">GST</span>
      Receipt
    </button>
    <button *ngIf="showRefundOptions()"
            type="button"
            class="btn btn-outline-primary"
            (click)="handleViewRefundOptions()">
      View Refund Options
    </button>
  </div>
  <div>
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Close
    </button>
  </div>
</div>
